import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import store from '@/store';
import {
  SHOW_REQUEST_ERROR,
  SHOW_REQUEST_SUCCESS
} from '@/store/constants/mutation-types';

Vue.use(VueAxios, axios);

Vue.axios.interceptors.response.use(
  response => {
    const statusCodes = [201, 204];
    if (statusCodes.includes(response.status)) {
      store.commit(`SuccessModule/${SHOW_REQUEST_SUCCESS}`);
    }
    return response;
  },
  error => {
    store.commit(`ErrorModule/${SHOW_REQUEST_ERROR}`, {
      errorText: error.response.data.message
        ? error.response.data.message
        : 'Oops Error Occured!'
    });
    return Promise.reject(error);
  }
);
